import AuthenticateUser from "../AuthenticateUser";
import ResponseBase from "./ResponseBase";

export default class AuthenticationResponse extends ResponseBase {
    public authenticateUser!: AuthenticateUser;
    public bnsToken!: string;
}
